import { render } from "./ForgotPasswordProcessForm.vue?vue&type=template&id=d1503712"
import script from "./ForgotPasswordProcessForm.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordProcessForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__